import getProductTourSteps from './product.steps';

export default getProductTourSteps;
